import Spinner, { SpinnerAction } from './Spinner';

export default Spinner;
export { SpinnerAction };
